module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded-title"
  }, [_c('span', [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("I would like to dedicate this book as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("Chapter One is dedicated to Brian Garfield.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Chapter Five is dedicated to Abby Adams.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Chapter Seven is dedicated to Justin Scott.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Chapter Thirty-four is dedicated to Joan Rivers.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Chapter Thirty-five is dedicated to George Movshon.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Chapter Thirty-nine is dedicated to Pete Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Chapter Forty-three is dedicated to Rich Barber.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("And all the other Chapters are dedicated to You, dear reader, with my thanks.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 75
// module chunks = 0